/**
 * Helper for transforming a bunch of items into an imageSet string
 *
 * @param images
 * @return {string}
 */
function generateSrcSet(images = []) {
    let srcset = "";

    if (!images.length) {
        return "";
    }

    images.forEach((image) => {
        srcset += `${image.image_url} ${image.image_width}w,\n`;
    });

    // Remove the "," from the last item
    return srcset.slice(0, -1);
}

/**
 * Helper for automatically transforming our Statamic asset to an srcSet string
 *
 * @param {Object} statamicAsset
 * @return {String}
 */
function statamicApiAssetToSrcSet(statamicAsset) {
    const images = [
        {
            image_url: statamicAsset.small_w300_permalink,
            image_width: 300,
        },
        {
            image_url: statamicAsset.small_w500_permalink,
            image_width: 500,
        },
        {
            image_url: statamicAsset.small_w750_permalink,
            image_width: 750,
        },
    ];

    return generateSrcSet(images);
}

module.exports = {
    generateSrcSet,
    statamicApiAssetToSrcSet,
};
